import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, useSlots } from 'vue';
import type { StyleValue } from 'vue/types/jsx';

export interface Props {
  width?: string;
  height?: string;
  noBodyPadding?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NavDropdown',
  props: {
    width: null,
    height: null,
    noBodyPadding: { type: Boolean }
  },
  setup(__props: any, { expose }) {

const props = __props as {
  width?: string;
  height?: string;
  noBodyPadding?: boolean;
};



const slots = useSlots();

const active = ref(false);

const rootStyle = computed(() => {
  const values: StyleValue = {};

  if (props.width) {
    values.width = props.width;
  }

  if (props.height) {
    values.height = props.height;
  }

  return values;
});

const bodyStyle = computed(() => {
  const values: StyleValue = {};

  if (props.noBodyPadding) {
    values.padding = '0';
  }

  return values;
});

/**
 * Toggle dropdown.
 */
function toggle() {
  if (!active.value) {
    open();
  } else {
    close();
  }
}

/**
 * Open dropdown.
 */
function open() {
  active.value = true;
}

/**
 * Close dropdown.
 */
function close() {
  active.value = false;
}

expose({ toggle });

return { __sfc: true,props, slots, active, rootStyle, bodyStyle, toggle, open, close }
}

})